import React from 'react';
import PropTypes from 'prop-types';

import {
    StyledTourCardBadge,
    StyledTourCardBadgeText,
} from './StyledComponents';

const propTypes = {
    tourState: PropTypes.oneOf(['active', 'inactive', 'empty']),
};

const defaultProps = {
    tourState: 'empty',
};

const BADGE_SETTINGS = {
    active: {
        label: 'Published',
        color: 'green',
    },
    inactive: {
        label: 'Unpublished',
        color: 'grey',
    },
    empty: {
        label: '3D tour',
        color: 'grey',
    },
    hidden: {
        label: 'Hidden',
        color: 'grey',
    },
};

const TourCardBadge = ({ tourState }) => {
    const settings = BADGE_SETTINGS[tourState];
    return (
        <StyledTourCardBadge color={settings.color}>
            <StyledTourCardBadgeText fontColor="white" fontType="fineprint">{settings.label}</StyledTourCardBadgeText>
        </StyledTourCardBadge>
    );
};

TourCardBadge.propTypes = propTypes;
TourCardBadge.defaultProps = defaultProps;

export default TourCardBadge;
